import React from 'react';

import { xcss, Box } from '@atlaskit/primitives';

const SpaceSettingsPageContainerStyles = xcss({
	backgroundColor: 'elevation.surface',
	height: '100%',
	paddingBlock: 'space.600',
	paddingInline: 'space.800',
});

export const SpaceSettingsPageContainer = ({
	children,
	testId,
}: {
	children: React.ReactNode;
	testId?: string;
}) => (
	<Box xcss={SpaceSettingsPageContainerStyles} testId={testId}>
		{children}
	</Box>
);
